namespace AgerLMS.WebSite {
    export interface CartProduct {
        CartKey?: string;
        Quantity?: number;
        Id?: number;
        TypeKey?: string;
        Type?: string;
        EntityType?: EntityTypes;
        ParentId?: number;
        Description?: string;
        ItemName?: string;
        ItemUrl?: string;
        ItemFullUrl?: string;
        InsertDate?: string;
        PublishDate?: string;
        ProfileUrl?: string;
        CategoryId?: number;
        CategoryName?: string;
        Price?: number;
        SalePrice?: number;
        ItemCoverImage?: string;
        ItemThumbnailImage?: string;
        Discount?: number;
        ItemVideoSource?: string;
        ItemVideoUrl?: string;
        Duration?: number;
        UsagePeriod?: number;
        WatchCount?: number;
        SalesStatus?: number;
        IncludesCargoPrice?: boolean;
        StartDate?: string;
        EndDate?: string;
        InsertUser?: UserItem;
    }
}
